import { ImgContext } from '@utils/GlobalContext.js';
import { useContext, useState } from 'react';

interface ImageCarouselProps {
    onImageSelect: (base64: string, index: number) => void;
}

const ImageCarousel = ({ onImageSelect }: ImageCarouselProps) => {
    const { defaultImages } = useContext(ImgContext);
    const [currentIndex, setCurrentIndex] = useState(0);

    const goToNext = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setCurrentIndex((prev) => (prev + 1) % defaultImages.length);
    };

    const goToPrevious = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();
        setCurrentIndex((prev) =>
            prev === 0 ? defaultImages.length - 1 : prev - 1
        );
    };

    const handleImageClick = () => {
        const base64 = `data:image/png;base64,${defaultImages[currentIndex]}`;
        onImageSelect(base64, currentIndex);
    };

    if (!defaultImages || defaultImages.length === 0) return null;

    const base64 = `data:image/png;base64,${defaultImages[currentIndex]}`;

    return (
        <div className=" d-flex align-items-center justify-content-center w-100 mb-4">
            <div className=" d-flex align-items-center justify-content-center w-75" style={{ gap: '10px'}}>
                <button
                    type="button"
                    onClick={goToPrevious}
                    className='hst-btn-carousel p-2'
                >
                    ←
                </button>

                <img
                    src={base64}
                    alt={`Immagine ${currentIndex + 1}`}
                    onClick={handleImageClick}
                    className='default-image-class'
                />

                <button
                    type="button"
                    className='hst-btn-carousel p-2'
                    onClick={goToNext}
                >
                    →
                </button>
            </div>
        </div>
    );
};

export default ImageCarousel;